import { type BuilderElement } from '@builder.io/sdk'

export const defaultColumns: BuilderElement[] = [
  {
    '@type': '@builder.io/sdk:Element',
    meta: {
      localizedTextInputs: ['title'],
    },
    component: {
      name: 'BigFooterColumn',
      options: {
        items: [
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Home',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Shop',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/shop',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'BODi',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/bodi',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Programs',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/programs',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Nutrition',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/nutrition',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'BODgroups',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/bodgroups',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'My Orders',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/myorders',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'The Office',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/theoffice',
            },
          },
        ],
        title: {
          '@type': '@builder.io/core:LocalizedValue',
          Default: 'Explore',
        },
      },
    },
  },
  {
    '@type': '@builder.io/sdk:Element',
    meta: {
      localizedTextInputs: ['title'],
    },
    component: {
      name: 'BigFooterColumn',
      options: {
        items: [
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'About Us',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/aboutus',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Corporate',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/corporate',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Investors',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/investors',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Careers',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/careers',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Scientific',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/scientific',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Advisory',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/advisory',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Board Press',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/boardpress',
            },
          },
        ],
        title: {
          '@type': '@builder.io/core:LocalizedValue',
          Default: 'Company',
        },
      },
    },
  },
  {
    '@type': '@builder.io/sdk:Element',
    meta: {
      localizedTextInputs: ['title'],
    },
    component: {
      name: 'BigFooterColumn',
      options: {
        items: [
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Privacy',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/privacy',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Do Not Sell My Info',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: ' Terms & Conditions',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/termsandconditions',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Accessibility Statement',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Supplier Code',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'California Supply Chain',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
            },
          },
        ],
        title: {
          '@type': '@builder.io/core:LocalizedValue',
          Default: 'Legal',
        },
      },
    },
  },
  {
    '@type': '@builder.io/sdk:Element',
    meta: {
      localizedTextInputs: ['title'],
    },
    component: {
      name: 'BigFooterColumn',
      options: {
        items: [
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Home',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Shop',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/shop',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'BODi',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/bodi',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Programs',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/programs',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'Nutrition',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/nutrition',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'BODgroups',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/bodgroups',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'My Orders',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/myorders',
            },
          },
          {
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'The Office',
            },
            href: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: '/theoffice',
            },
          },
        ],
        title: {
          '@type': '@builder.io/core:LocalizedValue',
          Default: 'Explore',
        },
      },
    },
  },
]

export const defaultDisclaimers: BuilderElement[] = [
  {
    '@type': '@builder.io/sdk:Element',
    component: {
      name: 'Text',
      options: {
        text: '<p>†Results vary depending on starting point and effort. Exercise and proper diet are necessary to achieve and maintain weight loss and muscle definition. The testimonials featured may have used more than one BODi product or extended the program to achieve their maximum results.</p><p><br></p><p>Consult your physician and follow all safety instructions before beginning any exercise program or nutrition plan, or using any supplement or meal replacement product, especially if you are pregnant, breastfeeding, have any medical condition, or are taking any medication. The contents on our website are for informational purposes only, and are not intended to diagnose any medical condition, replace the advice of a healthcare professional, or provide any medical advice, diagnosis, or treatment.</p><p><br></p><p>Distributed in the U.S. by BODi, 400 Continental Blvd., Suite 400, El Segundo, CA 90245.</p><p><br></p><p>© 2023 BODi. All rights reserved. All third-party trademarks are the property of their respective owners.  |  Sitemap</p>',
        style: 'Body XS',
      },
    },
  },
]
